import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=670232de&v-on-clickaway=cancel&"
import script from "./EditCustomer.vue?vue&type=script&lang=ts&"
export * from "./EditCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports